module.exports = __webpack_public_path__ + "img/averageLaborCostForThisMonth.6e96ca37.png";